import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Global } from 'src/app/global';
import { ModalDetalhesConsolidacaoIndicadoresApsComponent } from 'src/app/modals/modal-detalhes-consolidacao-indicadores-aps/modal-detalhes-consolidacao-indicadores-aps.component';
import { ApiService } from 'src/app/service/apiServices';
import { AuthService } from 'src/app/service/auth/auth.service';
import Swal from 'sweetalert2';

interface Dado {
  media: number;
  conceito: string;
  tipo: string;
  equipe: string;
}

interface DadoAgrupado {
  equipe: string;
  indicadores: {
    tipo: string;
    media: number;
    conceito: string;
  }[];
}

@Component({
  selector: 'app-indicadores-aps-odonto',
  templateUrl: './indicadores-aps-odonto.component.html',
  styleUrls: ['./indicadores-aps-odonto.component.css']
})
export class IndicadoresApsOdontoComponent implements OnInit {

   formulario: any = {
      nome_quadrimestre: null,
      ine_nome_equipe: null,
    };
    listaConfiguracoesPrevineBrasil: any[] = [];
    listaIne: any[] = [];
    configuracaoPrevineBrasilSelecionada: any = null;
    loading: boolean = false;
    listaIndicadoresConsolidados: any[] = [];
    modalRef: BsModalRef;
    detalhesConsolidado: any = {};
  
    constructor(
      private global: Global,
      private service: ApiService,
      private authService: AuthService,
      private modalService: BsModalService
    ) {}
  
    ngOnInit() {
      this.listarRegistrosPrevineBrasil();
      this.listarIne();
    }
  
    listarRegistrosPrevineBrasil() {
      this.loading = true;
      var url = "ConfiguracaoPrevineBrasil?Skip=1&Take=50";
      this.service
        .Get(url)
        .then((res: any) => {
          this.listaConfiguracoesPrevineBrasil = res.conteudo;
          this.loading = false;
        })
        .catch((res) => {
          if (res.status == 401 || res.error.status == 401) {
            Swal.close();
            this.authService.logoutUser();
          }
          Swal.close();
        });
    }
    listarIne() {
      this.loading = true;
      var url = "ConfiguracaoPrevineBrasil/Equipes";
      this.service
        .Get(url)
        .then((res: any) => {
          this.listaIne = res;
        })
        .catch((res) => {
          if (res.status == 401 || res.error.status == 401) {
            Swal.close();
            this.authService.logoutUser();
          }
          Swal.close();
        });
    }
    pesquisar() {
      this.loading = true;
      Swal.fire({
        title: "Aguarde...",
        text: "Estamos processando sua solicitação!",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      var filtro = {
        configuracao_previne_id: this.configuracaoPrevineBrasilSelecionada,
        cnes: "",
        cidadao: "",
        equipes: [],
        mudou: false,
        obito: false,
      };
      
      var url = `PrevineIndicadorOdonto/Equipe?configuracao_previne_id=${this.configuracaoPrevineBrasilSelecionada}`;
      
      if (this.formulario.ine_nome_equipe !== null) {
        url += `&ine=${this.formulario.ine_nome_equipe}`;
      } 
      this.service
        .Get(url)
        .then((res: any) => {
          Swal.close();
          this.loading = false;        
          if (res && res.conteudo.length > 0) {
            this.listaIndicadoresConsolidados = res.conteudo;
            //this.listaIndicadoresConsolidados = this.agruparPorEquipe(res);
            filtro.configuracao_previne_id = null;
            filtro.equipes = [];
            // this.formulario.ine_nome_equipe = null;
            // this.formulario.nome_quadrimestre = null;
            //this.configuracaoPrevineBrasilSelecionada = null;
          } else {
            this.listaIndicadoresConsolidados = [];
            Swal.fire(
              "Atenção",
              "Nenhum registro encontrado para os filtros informados.",
              "warning"
            );
          }
        })
        .catch((res) => {
          if (res.status == 401 || res.error.status == 401) {
            Swal.close();
            this.authService.logoutUser();
          } else {
            Swal.fire("Atenção", res.error, "error");
          }
          Swal.close();
        });
    }
    getMedia(equipe: any, tipo: string): string {
      const item = equipe.indicadores.find((i: any) => i.tipo === tipo);
      return item ? item.media.toFixed(2) : "-";
    }
  
    agruparPorEquipe(dados: Dado[]): DadoAgrupado[] {
      const agrupado: { [key: string]: DadoAgrupado } = {};
  
      dados.forEach((d) => {
        if (!agrupado[d.equipe]) {
          agrupado[d.equipe] = {
            equipe: d.equipe,
            indicadores: [],
          };
        }
  
        agrupado[d.equipe].indicadores.push({
          tipo: d.tipo,
          media: d.media,
          conceito: d.conceito,
        });
      });
      return Object.values(agrupado);
    }
    calcularMedia(media) {
      if (media === undefined || media === 0) return " - ";
  
      return Math.floor(media * 100) / 100;
    }
    getNotaClass(nota: number): string {
      if (nota === undefined) nota = 0;
  
      if (nota <= 25) {
        return "text-indicador-vermelho";
      } else if ( nota > 25 && nota <= 50) {
        return "text-indicador-amarelo";
      } else if (nota > 50 && nota <= 75) {
        return "text-indicador-verde";
      } else if (nota > 75){
        return "text-indicador-azul";
      }
    }
  
    abrirModalDetalhes(indicador: any, equipe: string) {
      var tipo = "";
      var url = ``;
      var rota = "";
      switch (indicador) {
        case "PRIMEIRA_CONSULTA":
          (tipo = "PRIMEIRA_CONSULTA"), (rota = `PrimeiraConsulta`);
          break;
        case "TRATAMENTO_CONCLUIDO":
          (tipo = "TRATAMENTO CONCLUIDO"), (rota = `TratamentoConcluido`);
          break;
        case "TAXA_EXODONTIA":
          (tipo = "TAXA_EXODONTIA"), (rota = `TaxaExodontia`);
          break;
        case "TRATAMENTO_RESTAURADOR":
          (tipo = "TRATAMENTO_RESTAURADOR"), (rota = `TratamentoRestaurador`);
          break;
        case "ESCOVACAO_SUPERVISIONADA":
          (tipo = "ESCOVACAO_SUPERVISIONADA"), (rota = `EscovacaoSupervisionada`);
          break;
        case "PROCEDIMENTO_PREVENTIVO":
          (tipo = "PROCEDIMENTO_PREVENTIVO"), (rota = `ProcedimentoPreventivo`);
          break;        
        
      }
  
      url += `PrevineIndicadorOdonto/Equipe/${rota}?configuracao_previne_id=${this.configuracaoPrevineBrasilSelecionada}&ine=${equipe}`;
      
      this.service
        .Get(url)
        .then((res: any) => {
          this.detalhesConsolidado = res;
          this.abrirModal(tipo, equipe);
        })
        .catch((res) => {
          if (res.status == 401 || res.error.status == 401) {
            Swal.close();
            this.authService.logoutUser();
          } else {
            Swal.fire("Atenção", res.error, "error");
          }
          Swal.close();
        });
    }
    abrirModal(tipo: string, equipe: string) {
      console.log(this.detalhesConsolidado.conteudo[0])
      
      this.modalRef = this.modalService.show(
        ModalDetalhesConsolidacaoIndicadoresApsComponent,
        {
          initialState: {
            dado: this.detalhesConsolidado.conteudo[0],
            tipoIndicador: tipo,
            equipe: equipe,
          },
          class: "modal-lg",
        }
      );
    }

}
